'use client'

import { useParams, useRouter } from 'next/navigation'
import { useEffect } from 'react'

import Spinner from '@components/ui/spinner'
import { landingPath } from '@lib/use-app-route'
import { isValidSlug } from '@server/orbit/helpers/slug'

const TeamIndexPage = () => {
  const router = useRouter()
  const params = useParams<{ team?: string }>()
  const team = typeof params?.team === 'string' ? params.team : undefined

  useEffect(() => {
    if (!team) return
    router.replace(isValidSlug(team) ? landingPath(team) : '/')
  }, [team, router])

  return (
    <div className="flex flex-1 items-center justify-center">
      <Spinner />
    </div>
  )
}

export default TeamIndexPage
